export const envs = {
  API_HOST: process.env.NX_PUBLIC_API_HOST || '',
  STATIC_ASSETS_URL: process.env.NX_PUBLIC_STATIC_ASSETS_URL,
  MY_TRACKER_ID: process.env.NX_PUBLIC_MY_TRACKER_ID || '',
  YA_METRIKA_ID: process.env.NX_PUBLIC_YA_METRIKA_ID || '',
  VK_HOST_DESKTOP: process.env.NX_PUBLIC_VK_HOST_DESKTOP || '',
  GOOGLE_PLAY_STORE_URL: process.env.NX_PUBLIC_GP_STORE_URL || '',
  APP_STORE_URL: process.env.NX_PUBLIC_APP_STORE_URL || '',
};
